<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item
        label="活动名称"
        prop="name"
        :rules="[
                { required: true, message: '请输入活动名称', trigger: 'blur' },
                ]"
      >
        <el-input v-model="form.name" placeholder="请输入活动名称" :clearable="true" style="width:217px"></el-input>
      </el-form-item>
      <el-form-item label="活动标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入活动标题" :clearable="true" style="width:217px"></el-input>
      </el-form-item>
      <el-form-item label="活动副标题" prop="subTitle">
        <el-input
          v-model="form.subTitle"
          placeholder="请输入活动副标题"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="背景图片"
        required
        prop="backImg"
        :rules="[
        { required: true, message: '请上传背景图片', trigger: 'change' },]"
      >
        <uploadImg v-model="form.backImg" :max="1" :text="['图片大小500kb以内']"></uploadImg>
      </el-form-item>
      <el-form-item label="基础权益名称" prop="baseInterestsName">
        <el-input
          v-model="form.baseInterestsName"
          placeholder="请输入基础权益名称"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="加速权益名称" prop="speedUpInterestsName">
        <el-input
          v-model="form.speedUpInterestsName"
          placeholder="请输入加速权益名称"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="加速所需成长币数量" prop="creditCount">
        <el-input
          v-model.number="form.creditCount"
          placeholder="请输入加速所需成长币数量"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="加速倍数" prop="speedUpMultiple">
        <el-input
          v-model.number="form.speedUpMultiple"
          placeholder="请输入加速倍数"
          :clearable="true"
          style="width:217px"
        ></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
      <!-- <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;"> -->
      <el-collapse accordion>
        <el-collapse-item v-for="(item, index) in form.grades" :key="index">
          <span
            style="font-size:14px;font-weight:600; margin:20px;"
            slot="title"
          >成长 [等级{{index + 1}}] (经验值:{{item.growthCount}})</span>
          <div
            style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
          >成长 [等级{{index + 1}}] (经验值:{{item.growthCount}})</div>
          <el-form-item
            label="等级名称"
            required
            :prop="'grades.' + index + '.name'"
            :rules="rules.name"
          >
            <el-input v-model="item.name" placeholder="请输入等级名称" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item
            label="所需成长值"
            required
            :prop="'grades.' + index + '.growthCount'"
            :rules="[
                { required: true, message: '所需成长值不能为空', trigger: 'blur' },
                { type: 'number', message: '所需成长值必须为数字值' },
                    { pattern: /^\+?[1-9][0-9]*$/, message: '请输入大于0的整数',trigger: 'blur'}
                ]"
          >
            <el-input v-model.number="item.growthCount" placeholder="请输入" :clearable="true"></el-input>
          </el-form-item>
          <div>
            <el-collapse accordion>
              <el-collapse-item>
                <span slot="title" style="margin-left: 100px;">
                  普通奖品(基础权益奖品)
                  <i class="header-icon el-icon-info"></i>
                </span>
                <div
                  style="border:1px solid #DCDFE6;width:98%;padding:0 0 20px 0;margin: 0px auto;margin-bottom: 20px;"
                >
                  <div style="text-align: center;margin: 20px auto;color:#ff3e55">普通奖品(基础权益奖品)</div>
                  <div
                    v-for="(item2, index2) in item.gifts"
                    :key="index2"
                    style="margin-top: 20px;"
                  >
                    <div v-if="item2.gradeType == 0">
                      <el-form-item
                        label="奖品名称"
                        required
                        :prop="'grades.'+index+'.gifts.'+index2+'.name'"
                        :rules="[
                { required: true, message: '奖品名称不能为空', trigger: 'blur' },
                ]"
                      >
                        <el-input
                          v-model.number="item2.name"
                          placeholder="请输入奖品名称"
                          :clearable="true"
                          style="width:217px"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="奖品数量"
                        required
                        :prop="'grades.'+index+'.gifts.'+index2+'.count'"
                        :rules="[
                { required: true, message: '奖品数量不能为空', trigger: 'blur' },
                { type: 'number', message: '奖品数量必须为数字值' },
                    { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}
                ]"
                      >
                        <el-input
                          v-model.number="item2.count"
                          placeholder="请输入奖品数量"
                          :clearable="true"
                          style="width:217px"
                        ></el-input>
                      </el-form-item>
                      <!-- <el-form-item label="成长路径" required>
                <el-radio-group v-model="item2.gradeType">
                  <el-radio :label="0">普通</el-radio>
                  <el-radio :label="1">加速</el-radio>
                </el-radio-group>
                      </el-form-item>-->

                      <el-collapse accordion>
                        <el-collapse-item>
                          <span
                            style="font-size:14px;font-weight:600; margin:20px;padding-left:110px"
                            slot="title"
                          >
                            奖品信息
                            <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>
                          </span>
                          <el-form-item
                            label="icon"
                            :prop="'grades.'+index+'.gifts.'+index2+'.icon'"
                            :rules="[{ required: true, message: '请上传icon', trigger: 'change' },]"
                          >
                            <uploadImg v-model="item2.icon" :max="1" :text="['图片大小500kb以内']"></uploadImg>
                          </el-form-item>
                          <el-form-item label="类型" required>
                            <prizeType
                              @skuType="skuTypes"
                              @getselect="getselects"
                              :prizeindex="index2"
                              :prizesindex="index"
                              :type="item2.type"
                              :prizeval="item2.value"
                            ></prizeType>
                          </el-form-item>
                        </el-collapse-item>
                      </el-collapse>
                      <div style="display: flex;justify-content: center;">
                        <el-button type="primary" size="mini" @click="addPrize(index,0)">+增加奖品</el-button>
                        <el-button
                          type="danger"
                          size="mini"
                          @click="removePrize(index,index2)"
                          v-if="index2 !== 0"
                        >-删除奖品</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item>
                <span slot="title" style="margin-left: 100px;">
                  加速奖品(精英权益奖品)
                  <i class="header-icon el-icon-info"></i>
                </span>
                <div
                  style="border:1px solid #DCDFE6;width:98%;padding:0 0 20px 0;margin: 0px auto;margin-bottom: 20px;"
                >
                  <div style="text-align: center;margin: 20px auto;color:#ff3e55">加速奖品(精英权益奖品)</div>
                  <div
                    v-for="(item2, index2) in item.gifts"
                    :key="index2"
                    style="margin-top: 20px;"
                  >
                    <div v-if="item2.gradeType == 1">
                      <el-form-item
                        label="奖品名称"
                        required
                        :prop="'grades.'+index+'.gifts.'+index2+'.name'"
                        :rules="[
                { required: true, message: '奖品名称不能为空', trigger: 'blur' },
                ]"
                      >
                        <el-input
                          v-model.number="item2.name"
                          placeholder="请输入奖品名称"
                          :clearable="true"
                          style="width:217px"
                        ></el-input>
                      </el-form-item>

                      <el-form-item
                        label="奖品数量"
                        required
                        :prop="'grades.'+index+'.gifts.'+index2+'.count'"
                        :rules="[
                { required: true, message: '奖品数量不能为空', trigger: 'blur' },
                { type: 'number', message: '奖品数量必须为数字值' },
                    { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}
                ]"
                      >
                        <el-input
                          v-model.number="item2.count"
                          placeholder="请输入奖品数量"
                          :clearable="true"
                          style="width:217px"
                        ></el-input>
                      </el-form-item>
                      <!-- <el-form-item label="成长路径" required>
                <el-radio-group v-model="item2.gradeType">
                  <el-radio :label="0">普通</el-radio>
                  <el-radio :label="1">加速</el-radio>
                </el-radio-group>
                      </el-form-item>-->

                      <el-collapse accordion>
                        <el-collapse-item>
                          <span
                            style="font-size:14px;font-weight:600; margin:20px;padding-left:110px"
                            slot="title"
                          >
                            奖品信息
                            <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>
                          </span>
                          <el-form-item
                            label="icon"
                            :prop="'grades.'+index+'.gifts.'+index2+'.icon'"
                            :rules="[{ required: true, message: '请上传icon', trigger: 'change' },]"
                          >
                            <uploadImg v-model="item2.icon" :max="1" :text="['图片大小500kb以内']"></uploadImg>
                          </el-form-item>
                          <el-form-item label="类型" required>
                            <prizeType
                              @skuType="skuTypes"
                              @getselect="getselectplus"
                              :prizeindex="index2"
                              :prizesindex="index"
                              :type="item2.type"
                              :prizeval="item2.value"
                            ></prizeType>
                          </el-form-item>
                        </el-collapse-item>
                      </el-collapse>
                      <div style="display: flex;justify-content: center;">
                        <el-button type="primary" size="mini" @click="addPrize(index,1)">+增加奖品</el-button>
                        <el-button
                          type="danger"
                          size="mini"
                          @click="removePrize(index,index2)"
                          v-if="index2 !== 1"
                        >-删除奖品</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div style="text-align: center;margin-bottom: 30px;">
            <!-- <el-button type="primary" size="mini" @click="addList()">添加成长等级</el-button> -->
            <el-button
              type="danger"
              size="mini"
              @click="removeList(index)"
              v-if="index !== 0"
            >删除成长等级</el-button>
          </div>
        </el-collapse-item>
        <div style="text-align: center;margin-bottom: 30px;">
          <el-button type="primary" size="mini" @click="addList()">添加成长等级</el-button>
          <!-- <el-button
              type="danger"
              size="mini"
              @click="removeList(index)"
              v-if="index !== 0"
          >删除成长等级</el-button>-->
        </div>
      </el-collapse>
      <!-- </div> -->
    </el-form>
    <div class="footer" v-if="growingAgreementT">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="success" @click="getModify('form')">新增</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="success" @click="getsEdit('form')">修改</el-button>
    </div>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import { getAdd, getInfo, getEidt } from '@/api/demo/growMent/index'
import prizeType from '@/components/prizeType/index.vue'
export default {
  name: 'growAddM',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImg,
    prizeType
  },
  data () {
    return {
      form: {
        title: '', // 活动标题
        subTitle: '', // 副标题
        backImg: '', // 背景图片
        baseInterestsName: '', // 基础权益名称
        speedUpInterestsName: '', // 加速权益名称
        creditCount: null, // 加速所需成长币数量
        speedUpMultiple: null, // 加速倍数
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        grades: [
          {
            gifts: [
              {
                count: 0, // 数量
                gradeType: 0, // 成长路径 0 普通 1 加速
                icon: '', // 图标
                icon2: [], // 图标
                type: 0, // 类型
                value: '', // 虚拟值
                value2: '',
                getCardList: [] // 卡片集合
              },
              {
                count: 0, // 数量
                gradeType: 1, // 成长路径 0 普通 1 加速
                icon: '', // 图标
                type: 0, // 类型
                value: '', // 虚拟值
                value2: '',
                getCardList: [] // 卡片集合
              }
            ], // 奖品
            growthCount: null, // 所需成长值
            name: '' // 等级名称
          }
        ]
      },
      growingAgreementId: null,
      growingAgreementT: true,
      rules: {
        title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        baseInterestsName: [
          { required: true, message: '请输入基础权益名称', trigger: 'blur' }
        ],
        speedUpInterestsName: [
          { required: true, message: '请输入加速权益名称', trigger: 'blur' }
        ],
        creditCount: [
          { required: true, message: '请输入加速所需成长币数量' },
          { type: 'number', message: '可加速所需成长币数量必须为数字值' },
          {
            pattern: /^\+?[1-9][0-9]*$/,
            message: '请输入大于0的整数',
            trigger: 'blur'
          }
        ],
        speedUpMultiple: [
          { required: true, message: '加速倍数不能为空', trigger: 'blur' },
          { type: 'number', message: '加速倍数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let that = this
    that.growingAgreementId = that.$route.query.id
    if (that.$route.query.id != null) {
      that.getgrowingInfo(that.$route.query.id)
      that.growingAgreementT = false
    }
  },
  methods: {
    getgrowingInfo (id) {
      let that = this
      getInfo(id).then(res => {
        that.form = res
      })
    },
    // 奖品类型
    skuTypes (val1, val2, val3) {
      let that = this
      // let that = this;
      for (
        let index = 0;
        index < that.form.grades[val3].gifts.length;
        index++
      ) {
        if (index == val2) {
          console.log('index == val2', index == val2, index)
          that.form.grades[val3].gifts[index].type = val1
        }
      }
    },
    getselects (val1, val2, val3) {
      let that = this
      for (
        let index = 0;
        index < that.form.grades[val3].gifts.length;
        index++
      ) {
        if (index == val2) {
          that.form.grades[val3].gifts[index].value = val1
        }
      }
    },
    // 加速--奖品类型
    skusType (val1, val2, val3) {
      let that = this
      for (
        let index = 0;
        index < that.form.grades[val3].gifts.length;
        index++
      ) {
        if (index == val2) {
          that.form.grades[val3].gifts[index].type = val1
        }
      }
    },
    getselectplus (val1, val2, val3) {
      let that = this
      for (
        let index = 0;
        index < that.form.grades[val3].gifts.length;
        index++
      ) {
        if (index == val2) {
          that.form.grades[val3].gifts[index].value = val1
        }
      }
    },
    // 增加奖品
    addPrize (index, gradeType) {
      this.form.grades[index].gifts.push({
        count: null, // 数量
        gradeType: gradeType, // 成长路径 0 普通 1 加速
        icon: '', // 图标
        icon2: [], // 图标
        type: 0, // 类型
        value: '', // 虚拟值
        value2: '',
        getCardList: [] // 卡片集合
      })
    },
    // 删除奖品
    removePrize (index, index2) {
      this.form.grades[index].gifts.splice(index2, 1)
      this.form.grades[index].gifts.forEach((item3, index3) => {
        item3.index = index3
      })
    },
    // 新增等级
    addList () {
      this.form.grades.push({
        gifts: [
          {
            count: 0, // 数量
            gradeType: 0, // 成长路径 0 普通 1 加速
            icon: '', // 图标
            icon2: [], // 图标
            type: 0, // 类型
            value: '', // 虚拟值
            value2: '',
            getCardList: [] // 卡片集合
          },
          {
            count: 0, // 数量
            gradeType: 1, // 成长路径 0 普通 1 加速
            icon: '', // 图标
            icon2: [], // 图标
            type: 0, // 类型
            value: '', // 虚拟值
            value2: '',
            getCardList: [] // 卡片集合
          }
        ], // 奖品
        growthCount: null, // 所需成长值
        name: '' // 等级名称
      })
    },
    // 删除等级
    removeList (index) {
      this.form.grades.splice(index, 1)
      this.form.grades.forEach((item, index) => {
        item.index = index
      })
    },
    // 取消
    cancel () {
      let that = this
      that.$router.push('/demo/growMent')
    },
    // 新增
    getModify (forms) {
      let that = this
      const set = this.$refs
      set[forms].validate(valid => {
        if (valid) {
          getAdd(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/growMent')
          })
        }
      })
    },
    // 修改
    getsEdit (forms) {
      let that = this
      const set = this.$refs
      console.log('that.form', that.form)
      set[forms].validate(valid => {
        console.log('valid', valid)
        if (valid) {
          getEidt(that.growingAgreementId, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/growMent')
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
}
</style>
